import config from 'config'

const SDK_ELEMENT_ID = 'facebook-jssdk'
const SDK_SRC = 'https://connect.facebook.net/en_US/sdk.js'

const FB_SESSION_KEY = 'shop/user/facebook-session'

let sdkPromise: Promise<any> = null

export function loadFacebookSDK (): Promise<any> {
  if (sdkPromise) return sdkPromise

  sdkPromise = new Promise((resolve, reject) => {
    const w = window as any
    if (w.FB) {
      resolve(w.FB)
      return
    }

    w.fbAsyncInit = function () {
      w.FB.init({
        appId: config.socialLogin.clientIdFacebook,
        cookie: true,
        version: 'v13.0'
      })
      resolve(w.FB)
    }

    let js = document.getElementById(SDK_ELEMENT_ID) as HTMLScriptElement
    if (!js) {
      const firstScript = document.getElementsByTagName('script')[0]
      js = document.createElement('script')
      js.id = SDK_ELEMENT_ID
      js.async = true
      js.src = SDK_SRC
      firstScript.parentNode.insertBefore(js, firstScript)
    }
    js.addEventListener('error', () => {
      js.remove()
      sdkPromise = null
      reject(new Error('Facebook SDK failed to load'))
    }, { once: true })
  })

  return sdkPromise
}

export function markFacebookSession (): void {
  try {
    localStorage.setItem(FB_SESSION_KEY, '1')
  } catch (error) {
    console.error('Could not record the Facebook session marker: ', error)
  }
}

export function hasFacebookSession (): boolean {
  try {
    return localStorage.getItem(FB_SESSION_KEY) === '1'
  } catch (error) {
    return false
  }
}

export function clearFacebookSession (): void {
  try {
    localStorage.removeItem(FB_SESSION_KEY)
  } catch (error) {
    console.error('Could not clear the Facebook session marker: ', error)
  }
}
